import React from "react";
import { TbAlertTriangle } from "react-icons/tb";

// "a", "a and b", "a, b and c"
const joinEmails = emails =>
  emails.length > 1 ? `${emails.slice(0, -1).join(", ")} and ${emails[emails.length - 1]}` : emails[0];

/**
 * Warns when a connected inbox had no emails when it was first synced.
 * The backend clears `is_inbox_empty` once emails arrive, so the banner goes away on its own.
 */
const EmptyInboxBanner = ({ accounts, className = "" }) => {
  const emptyInboxEmails = (Array.isArray(accounts) ? accounts : [])
    .filter(account => account?.is_inbox_empty)
    .map(account => account.email);
  if (emptyInboxEmails.length === 0) return null;

  return (
    <div
      role="status"
      data-testid="empty-inbox-banner"
      className={`flex gap-3 rounded-md border border-[#FCD34D] px-4 py-2 text-[12px] lg:text-sm text-[#1f2937] font-dmsans ${className}`}
    >
      {/* The column stretches to the text's height and the icon fills it (capped by the column width) */}
      <div className="relative shrink-0 w-12 lg:w-16 text-[#FCD34D]" aria-hidden="true">
        <TbAlertTriangle className="absolute inset-0 w-full h-full" />
      </div>
      <div>
        <p className="font-semibold">
          {emptyInboxEmails.length > 1 ? "Some of your inboxes are empty" : "Your inbox is empty"}
        </p>
        <p>
          We checked <span className="font-medium break-all">{joinEmails(emptyInboxEmails)}</span> and found no emails,
          so there&apos;s nothing to sync yet. New emails will show up here automatically. Expecting emails? Make sure
          you connected the right inbox.
        </p>
      </div>
    </div>
  );
};

export default EmptyInboxBanner;
